export default __webpack_public_path__ + "static/Anca_V1@2x-88defdd4af3d0e193c59d27311d0a95f.png";